import { Fan, KeyRound, Vote, AlarmClockCheck, TrendingUp, Heart, Award, Globe, Zap, Shield, Users } from 'lucide-react';

// Importation des animations Lottie
// Animations Lottie (chargées depuis le dossier public pour de meilleures performances au build)
const web = "/animations/Web_Development.json";
const App = "/animations/Mobile.json";
const pass = "/animations/Password.json";
const cyber = "/animations/Software.json";

// Importation des logos partenaires
import oracle from "../../assets/oracle.jpg";
import azure from "../../assets/azure2.png";
import aws from "../../assets/aws.jpg";
import globusre from "../../assets/globusre.png";
import cisco from "../../assets/cisco.png";
import Ncare from "../../assets/Ncare.png";
import google from "../../assets/google.png";
import togo from "../../assets/togo.png";

// ================================================
// DONNÉES DES PARTENAIRES
// ================================================
export const partners = [
    { id: 1, logo: oracle, name: "Oracle" },
    { id: 2, logo: azure, name: "Microsoft Azure" },
    { id: 3, logo: aws, name: "AWS" },
    { id: 4, logo: cisco, name: "Cisco" },
    { id: 5, logo: google, name: "Google" },
    { id: 6, logo: globusre, name: "Globus RE" },
    { id: 7, logo: Ncare, name: "Ncare" },
    { id: 8, logo: togo, name: "Togo Telecom" },
];

// ================================================
// DONNÉES DES SERVICES
// ================================================
export const services = [
    {
        id: 1,
        title: "Développement d'applications web sur-mesure",
        text: "Nous concevons des sites web et applications métier complets, en utilisant les technologies les plus récentes pour offrir performance, sécurité et évolutivité.",
        icon: Globe,
        color: "from-blue-500 via-cyan-500 to-blue-600",
        hoverColor: "hover:from-blue-500/20 hover:via-cyan-500/20 hover:to-blue-600/20",
        animation: web
    },
    {
        id: 2,
        title: "Applications mobiles innovantes",
        text: "Nos équipes de développeurs mobiles expérimentées vous conseillent et prennent en charge le design, la programmation et le référencement de votre application.",
        icon: Zap,
        color: "from-cyan-500 via-blue-500 to-green-500",
        hoverColor: "hover:from-cyan-500/20 hover:via-blue-500/20 hover:to-green-500/20",
        animation: App
    },
    {
        id: 3,
        title: "Sécurisation des applications",
        text: "Nos experts en cybersécurité analysent la robustesse de vos applications web et mobiles pour détecter les failles avant qu'elles ne soient exploitées.",
        icon: Shield,
        color: "from-green-500 via-emerald-500 to-cyan-500",
        hoverColor: "hover:from-green-500/20 hover:via-emerald-500/20 hover:to-cyan-500/20",
        animation: pass
    },
    {
        id: 4,
        title: "Audits de sécurité des infrastructures",
        text: "Évaluation complexe des risques et tests d'intrusion sur vos réseaux et systèmes pour mettre en lumière les brèches éventuelles.",
        icon: Users,
        color: "from-blue-600 via-cyan-500 to-green-500",
        hoverColor: "hover:from-blue-600/20 hover:via-cyan-500/20 hover:to-green-500/20",
        animation: cyber
    }
];

// ================================================
// DONNÉES DES FONCTIONNALITÉS (POURQUOI NOUS CHOISIR)
// ================================================
export const features = [
    {
        icon: Fan,
        title: "Expertise Technologique",
        desc: "Maîtrise des dernières technologies et frameworks pour des solutions à la pointe",
        linear: "from-blue-500/20 via-cyan-500/20 to-blue-600/20",
        delay: 0
    },
    {
        icon: Vote,
        title: "Stratégie & Vision",
        desc: "Solutions alignées sur vos objectifs métier avec une vision long terme",
        linear: "from-cyan-500/20 via-blue-500/20 to-green-500/20",
        delay: 0.1
    },
    {
        icon: KeyRound,
        title: "Solutions Clé-en-main",
        desc: "Déploiement complet et accompagnement jusqu'à la réussite de votre projet",
        linear: "from-green-500/20 via-emerald-500/20 to-cyan-500/20",
        delay: 0.2
    },
    {
        icon: AlarmClockCheck,
        title: "Suivi Continu Premium",
        desc: "Support 5/7 et maintenance proactive pour une tranquillité d'esprit totale",
        linear: "from-blue-600/20 via-cyan-500/20 to-green-500/20",
        delay: 0.0
    }
];

// ================================================
// DONNÉES DES STATISTIQUES
// ================================================
export const stats = [
    { number: "100+", label: "Projets Réalisés", icon: TrendingUp },
    { number: "88%", label: "Clients Satisfaits", icon: Heart },
    { number: "8+", label: "Prix d'Excellence", icon: Award },
    { number: "5/7", label: "Support Client", icon: AlarmClockCheck }
];

// ================================================
// TITRES ROTATIFS DU HERO
// ================================================
export const titres = ["Robustesse", "Sécurité", "Confiance", "Fiabilité", "Performance"];
